import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

export default function LineChartCustom({
  data,
  KeyXAxis = "",
  KeyYAxis = "",
  name = "",
  lineSecundary = false,
  KeyYAxislLineSecundary = false,
  namelineSecundary = "",
}) {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const data = payload[0] && payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #999",
            margin: 0,
            padding: 10,
            borderRadius: "5px",
            fontFamily: "Nunito",
            fontSize: "16px",
          }}
        >
          <p style={{ textAlign: "center", margin: "0px", padding: "0px" }}>
            {data[KeyXAxis]}
          </p>
          {KeyYAxislLineSecundary && data[KeyYAxislLineSecundary] && (
            <p
              style={{
                textAlign: "start",
                margin: "0px",
                padding: "0px",
                color: "#FC8618",
              }}
            >
              Paciente: {data[KeyYAxislLineSecundary]}{" "}
            </p>
          )}
          {data[KeyYAxis] && (
            <>
              <p
                style={{
                  textAlign: "start",
                  margin: "0px",
                  padding: "0px",
                  color: "#1E729F",
                }}
              >
                {name}: {data[KeyYAxis]}
              </p>

              {data.vinculo_ps_respondente && (
                <div
                  style={{
                    textAlign: "start",
                    margin: "0px",
                    padding: "0px",
                    paddingLeft: "10px",
                    color: "#737373",
                    fontSize: "12px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  }}
                >
                  <span
                    style={{ margin: "0px", padding: "0px", lineHeight: "6px" }}
                  >
                    Nome: {data.vinculo_ps_respondente.name}
                  </span>
                  <span style={{ margin: "0px", padding: "0px" }}>
                    cargo: {data.vinculo_ps_respondente.perfil}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      );
    }

    return null;
  };
  return (
    <ResponsiveContainer width="100%" height={400}>
      <LineChart width="100%" height={300} data={data}>
        <CartesianGrid vertical={false} />
        <XAxis
          axisLine={true}
          height={100}
          tickMargin={50}
          angle={48.74}
          dataKey={KeyXAxis}
          padding={{ left: 20, right: 20 }}
          tickSize={6}
          tick={{
            stroke: "#737373",
            fontWeight: "500",
            fontSize: "14px",
            fontFamily: "Nunito",
          }}
        />
        <YAxis
          axisLine={false}
          label={{ value: "Pontos", angle: -90, position: "insideLeft" }}
          interval={"preserveStartEnd"}
        />
        <Tooltip content={<CustomTooltip />} />
        <Line
          type="monotone"
          dataKey={KeyYAxis}
          stroke="#1E729F"
          strokeWidth={2}
          name={name}
          connectNulls
        />

        {lineSecundary && (
          <>
            <Line
              type="monotone"
              dataKey={KeyYAxislLineSecundary}
              stroke="#FC8618"
              strokeWidth={2}
              name={namelineSecundary}
              connectNulls
            />
            <Legend />
          </>
        )}
      </LineChart>
    </ResponsiveContainer>
  );
}
